const RESPONSE_FORMAT = 'json';

export function createFabric({ httpClient, urlPrefix = '', onActivity = null }) {
    const resolvePrefix = () => {
        const p = typeof urlPrefix === 'function' ? urlPrefix() : urlPrefix;
        return p ? `${p}/` : '';
    };

    function invokeMultipleCommands(arrCmds, abortSignal) {
        if (!arrCmds.length) { throw 'invalid array of fabric commands'; }

        const formatedCommands = [];
        arrCmds.forEach(cmd => {
            if (typeof cmd === 'string') {
                formatedCommands.push({ command: cmd });
            } else if (typeof cmd === 'object' && cmd !== null && cmd.command) {
                formatedCommands.push({
                    command: cmd.command,
                    params: cmd.params,
                });
            }
        });
        const prefix = resolvePrefix();
        return httpClient.invokeHTTPRequest(`${prefix}api/fabric-commands`, httpClient.POST_REQUEST, { commands: formatedCommands }, null, getCustomHeaders(httpClient.POST_REQUEST, httpClient.GET_REQUEST), undefined, false, abortSignal);
    }

    async function invokeCommands(cmds, abortSignal = null) {
        if (!cmds) { throw 'fabric commands wasn`t provided'; }
        if (onActivity) onActivity();
        return invokeMultipleCommands(Array.isArray(cmds) ? cmds : [cmds], abortSignal);
    }

    function invokeWS(name, paramsObj = null, verb = httpClient.GET_REQUEST, version, stream = false, servlet = 'api', abortSignal = null) {
        if (typeof name !== 'string') { throw 'name must be a string'; }
        if (!name) { throw 'name wasn`t provided'; }

        if (onActivity) onActivity();
        const prefix = resolvePrefix();
        const url = version ? `${prefix}${servlet}/${version}/${name}` : `${prefix}${servlet}/${name}`;
        return httpClient.invokeHTTPRequest(url, verb, paramsObj, getQSParams(paramsObj, verb, httpClient.GET_REQUEST), getCustomHeaders(verb, httpClient.GET_REQUEST), undefined, stream, abortSignal);
    }

    return { invokeCommands, invokeWS };
}

function getQSParams(paramsObj, verb, GET) {
    if (verb === GET) {
        paramsObj = paramsObj || {};
        return { format: RESPONSE_FORMAT, ...paramsObj };
    }
    return null;
}

function getCustomHeaders(verb, GET) {
    if (verb === GET) {
        return {};
    }
    return { 'Content-Type': 'application/json' };
}
